module.exports = __webpack_public_path__ + "static/media/general-de-seguros-off-app-provider-icon.9d0b4727.svg";